import request from '@/utils/request'
import { getShopId } from '@/api/shop/shopApi'

/**
 * 查询会员信息列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryShopVipUser(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopVipUser.queryShopVipUser',
      method: 'get',
      params: {
        ...params,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}